import { useTranslation } from 'react-i18next';
import { mainSiteUrl, heroImage } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />

      <div className="relative mx-auto flex min-h-[600px] max-w-7xl flex-col items-center justify-center px-4 md:px-6 py-24 text-center">
        <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.2em] text-background-50/90">
          {t('hero.eyebrow')}
        </p>
        <h1 className="mt-5 max-w-4xl font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
          {t('hero.title')}
        </h1>
        <p className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-background-50/90">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('hero.ctaPrimary')}
            <i className="ri-arrow-right-up-line" />
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-background-50/95 px-6 py-3 text-sm md:text-base font-semibold text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <p className="mt-6 flex items-center gap-2 text-xs md:text-sm text-background-50/80">
          <i className="ri-shield-check-line" />
          {t('hero.trust')}
        </p>
      </div>
    </section>
  );
}